<template>
    <div class="input-button">
        <input v-model="value" v-on:keydown="InputChange($event)" v-on:focus="Focus()" v-on:blur="Blur()">
        <buttonc styleIcon="font-size: 16px; height: 11px;" class="arrow-up" type="round small no-background no-hover" icon="fa-sort-up" @click="ArrowUp()"/>
        <buttonc styleIcon="font-size: 16px; height: 11px; top: -3px;" class="arrow-down" type="round small no-background no-hover" icon="fa-sort-down" @click="ArrowDown()"/>
    </div>
</template>

<script>
    export default {
        name: "inputbutton",
        data(){
            return{
                value: '',
                valueActual: '',
                valueLast: '',
                escapeBlur: new Date(),
                type: 'percent',
                DisplayValue: (value) => { return value },
                ValueCheck: (value) => { return true; }
            }
        },
        computed:{
        },
        watch: {
            state: {
                immediate: true,
                handler(newVal, oldVal) {
                    for (let x in newVal) this[x] = newVal[x];
                    this.valueActual = this.value;
                    this.valueLast = this.value;
                    if (this.type === 'percent') {
                        if(!newVal.DisplayValue) this.DisplayValue = this.DisplayValuePercent;
                        if(!newVal.ValueCheck) this.ValueCheck = this.ValidPercentCheck;
                    }
                    if(!this.$el || document.activeElement !== this.$el.querySelector('input')) this.value = this.DisplayValue(this.value);
                }
            }
        },
        props:{
            state: Object,
        },
        methods:{
            InputChange($event){
                let keyName = $event.key;
                if(keyName === "Enter" && this.ValueCheck(this.value)) {
                    this.$emit('input-change', this.value);
                    this.UpdateValueLast();
                }
                if(keyName === "Tab") {
                    if(this.ValueCheck(this.value)) {
                        this.escapeBlur = new Date();
                        this.$emit('input-change', this.value);
                        this.UpdateValueLast();
                        this.value = this.DisplayValue(this.value);
                    } else {
                        this.escapeBlur = new Date();
                        this.value = this.valueLast;
                        this.value = this.DisplayValue(this.valueLast);
                    }
                }
                if(keyName === "Escape") {
                    if(this.state) this.value = this.state.value;
                    else this.value = this.valueLast;
                    this.escapeBlur = new Date();
                }
                if(keyName === "ArrowUp") this.$emit('arrow-up', this.valueActual);
                if(keyName === "ArrowDown") this.$emit('arrow-down', this.valueActual);
                if(this.type === 'percent'){
                    if(keyName !== '-' && keyName !== '.' && !this.$helpers.IsKeyNameNavigationType(keyName)) {
                        if (isNaN(parseInt($event.key))) $event.preventDefault();
                    }
                }
            },
            ValidPercentCheck(value){
                return !isNaN(parseFloat(+value));
            },
            UpdateValueLast(){
                this.valueLast = this.valueActual = this.value;
            },
            DisplayValuePercent(value){
                if(typeof value === 'string') {
                    value = parseFloat(+value);
                }
                if(typeof value === 'number') value = value.toFixed(2);
                return value.split('%').join('') + '%';
            },
            Focus(){
                this.value = this.valueActual;
                this.valueLast = this.valueActual;
            },
            Blur(){
                if((new Date()) - this.escapeBlur < 100) return;
                if(this.ValueCheck(this.value)) {
                    this.UpdateValueLast();
                    this.$emit('input-change', this.value);
                    this.value = this.DisplayValue(this.value);
                } else {
                    this.valueActual = this.value = this.valueLast;
                    this.value = this.DisplayValue(this.valueActual);
                }
            },
            ArrowUp(){
                this.$emit('arrow-up', this.valueActual);
            },
            ArrowDown(){
                this.$emit('arrow-down', this.valueActual);
            }
        }
    }
</script>

<style scoped>
    .input-button{
        position: absolute;
        height: 100%;
        width: 100%;
        overflow: hidden;
        top: 0;
        left: 0;
    }

    .input-button > input{

        position: absolute;
        right: 5px;
        top: 0;
        bottom: 0;
        margin: auto;
        height: calc(100% - 10px);
        width: calc(100% - 20px);
        z-index: 2;
        border: none;
        background: none;
        box-shadow: none;
        text-align: right;
        font-size: inherit;
    }

    .arrow-up,.arrow-down{
        position: absolute;
        left: 0px;
        height: 10px;
        width: 10px;
        z-index: 2;
    }

    .arrow-up{
        top: 6px;
    }

    .arrow-down{
        bottom: 6px;
    }

    .row .entry.left  input{
        text-align: left;
    }

    .row .entry.center  input{
        text-align: center;
    }
    .row .entry.sides  input{
        text-align: justify-all;
    }

    .button{
        height: 15px !important;
    }
</style>